import {
  apiRequest,
  // PromotionPeriodList,
  // PromotionPeriodDetail
} from "../../../../../services/adapters/kepegawaian/revisiTunjanganKhususService";

class IndexRepository {
  // fetchAwardList = async (query, cancelToken) => {
  //     return await apiRequest("get", PromotionPeriodList, {
  //         cancelToken: cancelToken,
  //         params: query
  //     }, true)
  // }
  // fetchDetail = async (query, cancelToken) => {
  //     return await apiRequest("get", PromotionPeriodDetail, {
  //         cancelToken: cancelToken,
  //         params: query
  //     }, true)
  // }
}

export default IndexRepository;
